"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UnkownIssuerError = void 0;
var KeyRing_1 = __importDefault(require("./KeyRing"));
var debug_1 = __importDefault(require("debug"));
var Telemetry_1 = require("./Telemetry");
var debug = debug_1.default('jwt-cert-sdk:Authorities');
var UnkownIssuerError = /** @class */ (function (_super) {
    __extends(UnkownIssuerError, _super);
    function UnkownIssuerError() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return UnkownIssuerError;
}(Error));
exports.UnkownIssuerError = UnkownIssuerError;
/**
 * Helper to be used on any Agent that will need to be able to either:
 *  - Make a certificate signature request
 *  - Obtain public keys / certificate to validate a JCT
 */
var Authorities = /** @class */ (function () {
    function Authorities() {
        this._clients = {};
        this._authority_map = {};
        this.keyring = new KeyRing_1.default(this.obtain_key.bind(this));
    }
    /**
     * Add a root authority.
     */
    Authorities.prototype.addRootAuthority = function (client, authority_nickname) {
        if (authority_nickname === void 0) { authority_nickname = 'default'; }
        this._clients[client.issuer] = client;
        this._authority_map[authority_nickname] = client.issuer;
    };
    Authorities.prototype.obtain_key = function (issuer, keyid, telemetry) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!telemetry) {
                            telemetry = new Telemetry_1.Telemetry('Authorities obtain_key');
                        }
                        if (!(issuer in this._clients && this._clients[issuer])) return [3 /*break*/, 2];
                        return [4 /*yield*/, telemetry.seq('getPublicKey', function () { return _this._clients[issuer].getPublicKey(keyid); })];
                    case 1: return [2 /*return*/, _a.sent()];
                    case 2: return [2 /*return*/, null];
                }
            });
        });
    };
    Authorities.prototype.sign = function (jcr_encoded, authority_nickname) {
        if (authority_nickname === void 0) { authority_nickname = 'default'; }
        return __awaiter(this, void 0, void 0, function () {
            var client;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(authority_nickname in this._authority_map)) {
                            throw new Error("Authority " + authority_nickname + " not found");
                        }
                        if (!(this._authority_map[authority_nickname] in this._clients)) {
                            throw new Error("clients tampered with, expected service " + authority_nickname + " to have a client");
                        }
                        client = this._clients[this._authority_map[authority_nickname]];
                        return [4 /*yield*/, client.sendCertificateRequest(jcr_encoded)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    Authorities.prototype.isCertificateRevoked = function (jsc, list_ttl_in_seconds, telemetry) {
        if (list_ttl_in_seconds === void 0) { list_ttl_in_seconds = 3600; }
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(jsc.issuer in this._clients)) {
                            throw new UnkownIssuerError('Unkown issuer ' + jsc.issuer);
                        }
                        return [4 /*yield*/, this._clients[jsc.issuer].isCertificateRevoked(jsc.certificate_id, list_ttl_in_seconds, telemetry)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    Authorities.prototype.areAnyCertificateRevoked = function (jscs, list_ttl_in_seconds, telemetry) {
        if (list_ttl_in_seconds === void 0) { list_ttl_in_seconds = 3600; }
        return __awaiter(this, void 0, void 0, function () {
            var mapPerIssuer, ecs, checks, checkTelemetry, _loop_1, issuer;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!telemetry) {
                            telemetry = new Telemetry_1.Telemetry('Authorities areAnyCertificateRevoked');
                        }
                        telemetry.stamp('preparing');
                        mapPerIssuer = {};
                        ecs = [];
                        jscs.forEach(function (jsc, idx) {
                            var _a;
                            // add extended cert id to the list to verify on any issuer
                            if (jsc.body.ecs) {
                                ecs.push.apply(ecs, jsc.body.ecs);
                            }
                            if (!(jsc.issuer in mapPerIssuer)) {
                                if (!(jsc.issuer in _this._clients)) {
                                    if (idx === jscs.length - 1) {
                                        throw new UnkownIssuerError('Unkown issuer ' + jsc.issuer);
                                    }
                                    else {
                                        debug('Skipping unknown cert issuer %s', jsc.issuer);
                                        // do not verify this one, it was a middle cert
                                        return;
                                    }
                                }
                                mapPerIssuer[jsc.issuer] = [];
                            }
                            (_a = mapPerIssuer[jsc.issuer]).push.apply(_a, jsc.extended_certificate_ids);
                        });
                        checks = [];
                        checkTelemetry = telemetry.stamp('checks');
                        _loop_1 = function (issuer) {
                            var certificate_ids = mapPerIssuer[issuer];
                            // add ecs' certificate id to every issuer checked
                            ecs.forEach(function (cert_id) {
                                if (!certificate_ids.includes(cert_id)) {
                                    certificate_ids.push(cert_id);
                                }
                            });
                            checks.push(checkTelemetry.fork('issuer-' + issuer, function (t) {
                                return _this._clients[issuer].areAnyCertificateRevoked(certificate_ids, list_ttl_in_seconds, t);
                            }));
                        };
                        for (issuer in mapPerIssuer) {
                            _loop_1(issuer);
                        }
                        if (checks.length === 0) {
                            throw new Error('No isser were found');
                        }
                        return [4 /*yield*/, Promise.all(checks)];
                    case 1: return [2 /*return*/, (_a.sent()).reduce(function (p, c) { return p.concat(c); })];
                }
            });
        });
    };
    Authorities.prototype.revokeCertificate = function (jsc) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(jsc.issuer in this._clients)) {
                            throw new Error('Unkown issuer');
                        }
                        return [4 /*yield*/, this._clients[jsc.issuer].sendCertificateRevokationRequest(jsc.certificate_id)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    Authorities.prototype.getOwnCertificateList = function (issuer) {
        if (issuer === void 0) { issuer = undefined; }
        return __awaiter(this, void 0, void 0, function () {
            var list, k;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        list = [];
                        for (k in this._clients) {
                            if (issuer === k || !issuer) {
                                list.push(this._clients[k].getOwnCertificateList());
                            }
                        }
                        return [4 /*yield*/, Promise.all(list)];
                    case 1: 
                    // wait for all responses and return flatten array
                    return [2 /*return*/, (_a.sent()).reduce(function (p, c) { return p.splice.apply(p, __spreadArrays([0, 0], c)); })];
                }
            });
        });
    };
    return Authorities;
}());
exports.default = Authorities;
